import { OperatorWithStatus } from "gql/generated";
import { TFunction } from "i18next";
import { OperatorCard } from "shared/components/organisms/OperatorCard";
import { StatusIndicator } from "shared/components";
import { ButtonProps } from "@ttc3k/trekker";
import { getMultilingualString } from "shared/utils";
import { getStatusIndicatorByPublicationStatus } from "shared/utils";

/**
 * Get the operator card for the directory page
 * @param operator - The operator to get the card for
 * @param organizationId - The organization ID
 * @param t - The translation function
 * @param onOperatorClick - The function to call when the operator card is clicked
 * @returns The operator card
 */
export const OperatorCardRenderer = (
  operator: OperatorWithStatus,
  organizationId: string,
  t: TFunction,
  actionButtonProps?: ButtonProps,
) => {
  const statusInfo = getStatusIndicatorByPublicationStatus(
    operator,
    organizationId,
  );

  return (
    <OperatorCard
      hero={operator.images[0]}
      title={getMultilingualString(operator.name)}
      subTitle={
        operator.type && t(`core:LOOKUPS.OPERATOR_TYPE.${operator.type}`)
      }
      actionButtonProps={actionButtonProps}
      StatusIndicator={
        <StatusIndicator
          label={statusInfo.label}
          numBoxes={4}
          numFilled={statusInfo.numFilled}
          display={statusInfo.variant.display}
          visual={statusInfo.variant.visual}
        />
      }
    />
  );
};
